import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';

const ReprintDialog = ({
  open,
  onClose,
  pendingReprintOrder,
  onConfirm,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ color: "warning.main", fontWeight: 700 }}>
        Confirmar Reimpressão
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" mb={2}>
          O pedido{" "}
          <strong>
            {pendingReprintOrder?.content?.invoice_number ||
              pendingReprintOrder?._id}
          </strong>{" "}
          já foi impresso anteriormente.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Tem certeza que deseja imprimir a etiqueta novamente?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          color="inherit"
        >
          Cancelar
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="warning"
          autoFocus
        >
          Sim, Imprimir Novamente
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReprintDialog;